import { render, staticRenderFns } from "./Settle.vue?vue&type=template&id=3a98a1d1&scoped=true&"
import script from "./Settle.vue?vue&type=script&lang=tsx&"
export * from "./Settle.vue?vue&type=script&lang=tsx&"
import style0 from "./Settle.vue?vue&type=style&index=0&id=3a98a1d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98a1d1",
  null
  
)

export default component.exports